import { useCallback, useEffect } from 'react';
import { useRouter } from '@funtech-int/rival-react';
import { useAuthManager } from '@funtech-int/yango-shared';

import { removeQueryParamsFromUrl } from '@/shared/lib/navigation';
import { useProfileManager } from '@/shared/hooks/useProfileManager';
import { useSearchParams } from '@/shared/hooks/useSearchParams';

export const useAutoOpenPaymentWidgetParams = () => {
    const router = useRouter();
    const { isAuthorized } = useAuthManager();
    const { hasSpecificSubscription } = useProfileManager();

    const searchParams = useSearchParams();

    const isOpenPwQueryParam = searchParams.get('isOpenPw') ?? undefined;
    const billingFeatureNameQueryParam = searchParams.get('billingFeatureName') ?? undefined;
    const targetQueryParam = searchParams.get('target') ?? undefined;
    const watchAfterPurchaseQueryParam = searchParams.get('watchAfterPurchase') ?? undefined;

    const cleanOpenWidgetQuery = useCallback(
        () =>
            removeQueryParamsFromUrl({
                router,
                queryParams: ['isOpenPw', 'billingFeatureName', 'target'],
            }),
        [router]
    );

    const isOpenPw = isOpenPwQueryParam === '1';
    const hasWidgetQueryParams = targetQueryParam && billingFeatureNameQueryParam && isOpenPw;
    const shouldOpenWidgetFromQuery = Boolean(
        hasWidgetQueryParams &&
            !hasSpecificSubscription(billingFeatureNameQueryParam) &&
            isAuthorized
    );

    useEffect(() => {
        if (hasWidgetQueryParams && !shouldOpenWidgetFromQuery) {
            cleanOpenWidgetQuery();
        }
    }, [cleanOpenWidgetQuery, hasWidgetQueryParams, shouldOpenWidgetFromQuery]);

    return {
        target: targetQueryParam,
        billingFeatureName: billingFeatureNameQueryParam,
        watchAfterPurchase: watchAfterPurchaseQueryParam,
        shouldOpenWidgetFromQuery,
        cleanOpenWidgetQuery,
    };
};
